/**
 * @generated SignedSource<<1d6ba4a18f974e7310a6ceed7432f471>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MusicReprocessPieceInput = {
  piece_id: string;
};
export type ReprocessPieceMutation$variables = {
  input: MusicReprocessPieceInput;
};
export type ReprocessPieceMutation$data = {
  readonly music_reprocess_piece: {
    readonly piece: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PieceSettingsBody_piece">;
    };
  };
};
export type ReprocessPieceMutation = {
  variables: ReprocessPieceMutation$variables;
  response: ReprocessPieceMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReprocessPieceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MusicPieceOutput",
        "kind": "LinkedField",
        "name": "music_reprocess_piece",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PieceSettingsBody_piece"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReprocessPieceMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "MusicPieceOutput",
        "kind": "LinkedField",
        "name": "music_reprocess_piece",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "MusicPiece",
            "kind": "LinkedField",
            "name": "piece",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "end_to_end_test_file_download_url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "MusicPieceFile",
                "kind": "LinkedField",
                "name": "file",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "tempo",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c43c3c92a29b2cfededf2e03b9270061",
    "id": null,
    "metadata": {},
    "name": "ReprocessPieceMutation",
    "operationKind": "mutation",
    "text": "mutation ReprocessPieceMutation(\n  $input: MusicReprocessPieceInput!\n) {\n  music_reprocess_piece(input: $input) {\n    piece {\n      id\n      ...PieceSettingsBody_piece\n    }\n  }\n}\n\nfragment PieceSettingsBodyEmployeeOnlySection_piece on MusicPiece {\n  id\n  end_to_end_test_file_download_url\n}\n\nfragment PieceSettingsBody_piece on MusicPiece {\n  id\n  name\n  ...PieceSettingsNameItem_Piece\n  ...PieceSettingsBodyEmployeeOnlySection_piece\n  ...PieceSettingsTempoItem_piece\n}\n\nfragment PieceSettingsNameItem_Piece on MusicPiece {\n  id\n  name\n}\n\nfragment PieceSettingsTempoItem_piece on MusicPiece {\n  id\n  file {\n    tempo\n  }\n}\n"
  }
};
})();

(node as any).hash = "266b54551c11678976e9284894f13dc7";

export default node;
